/**
 * Chart colours for canvas and SVG, one step per mode, picked by `useIsDarkMode`.
 * Literal hex because chart.js cannot resolve a CSS custom property and the
 * `--color-*` tokens are `@theme inline`, so they emit no runtime value.
 */

/** A chart's single series: `--blue-500` in each mode, clear of the 3:1 floor for a mark. */
export const CHART_SERIES_COLOR = {
  light: "#0069e0",
  dark: "#3486e5",
} as const;

/** Hairline grid, one step off the surface in each mode. */
export const CHART_GRID_COLOR = {
  light: "#e0e0e0",
  dark: "#333333",
} as const;

export const CHART_AXIS_TEXT_COLOR = {
  light: "#767676",
  dark: "#bdbdbd",
} as const;

/** A mark that is past a limit or wrong. */
export const CHART_ALERT_COLOR = {
  light: "#bd002f",
  dark: "#f1cad3",
} as const;
